import { useSelector } from 'react-redux';
import { getAddItemsToCartData } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlist/selectors';

type UseAddItemsToCartDataReturnType = ReturnType<typeof getAddItemsToCartData>;

const useAddItemsToCartData = (): UseAddItemsToCartDataReturnType => useSelector(getAddItemsToCartData);

export type { UseAddItemsToCartDataReturnType };
export { useAddItemsToCartData };
